import gql from 'graphql-tag';

export default gql`
query GetAllVosUploads($input: GetAllVosUploadsInput) {
  getAllVosUploads(input: $input) {
    jobId
    wellName
    district
    customer
    week1
    downloadLinkWeek1
    week2
    downloadLinkWeek2
    week3
    downloadLinkWeek3
    week4
    downloadLinkWeek4
    week5
    downloadLinkWeek5
    week6
    downloadLinkWeek6
    downloadLinkMob
    downloadLinkDemob
  }
}
`;